import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useUserStore = create(
  persist(
    (set) => ({
      user: {},
      setUser: (newUser) =>
        set((state) => ({ user: { ...state.user, ...newUser } })),
      removeUser: () => {
        set(() => ({ user: {} }));
        localStorage.removeItem("token");
      },
    }),
    {
      name: "user",
    }
  )
);

export const useAuthStore = create((set) => ({
  authData: {},
  setAuth: (newData) =>
    set((state) => ({ authData: { ...state.authData, ...newData } })),
  removeAuthData: () => set(() => ({ authData: {} })),
}));
